

export const BASE_URL = 'https://stonecore-2024.uc.r.appspot.com';